import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from "react-intl";

// Assets
import {red500} from "assets/jss/main";

// Utils
import {LineItemStatus} from "utils/LineItemStatus";

IsServiceWarning.propTypes = {
    order: PropTypes.object.isRequired,
};

function IsServiceWarning({order}) {
    if (order.status === LineItemStatus.TO_SHIP) {
        return null;
    }

    const hasProductService = order.lineItems?.some((lineItem) =>
        lineItem.variation?.product?.attributes?.some(
            (attribute) => attribute.attribute.code === 'is_service' && attribute.value === true
        )
    );

    if (!hasProductService) {
        return null;
    }

    return (
        <div style={{color: red500}}>
            <FormattedMessage id='wms.packing.specialOrder.service'/>
        </div>
    );
}

export default IsServiceWarning;
